module.exports = __webpack_public_path__ + "static/media/piiwaiting.a47406ba.png";